// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import 'babel-polyfill'
import promise from 'es6-promise'
import request from "./utils/request"
import $const from "./utils/const"
import '../static/css/layout.css'
import './assets/css/style.css'
import params from './utils/params';
promise.polyfill()
Vue.config.productionTip = false
Vue.prototype.$request=request;
Vue.prototype.$params=params;
Vue.prototype.$const=$const;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js